<template>
    <div>
        <Html/>
    </div>
</template>

<script>
import Html from '../components/Html.vue';

export default {
  components: {
    Html,
  },
};
</script>

<style lang="scss" scoped>

</style>
